// src/Components/Forms/Financement/Mourabaha/Demande/Tab1.tsx

import React, { useState } from 'react';
import { Box, CircularProgress, Grid, Chip } from '@mui/material';
import { Button, Form } from 'antd';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import Params from '../../../../../Types/ParamsPicklist';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import Datas from '../../../../../Data/Data.json';
import InputForm from '../../../../InputT';
import SearchModal from '../../../../SearchModal';
import Utilisateur from '../../../../../Models/Utilisateur';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import { SwipeUp } from '@mui/icons-material';
import { Typography } from '@mui/material';
import SearchInput from '../../../../SearchInput';
import { useActifService } from '../../../../Hooks/GetDetailActif';

// ==================== PARAMÈTRES DE RECHERCHE ====================
let searchFinForm: Params = { CodeAgence: '', Table: "DEMAND_FINMOURABAHA", Colonne1: "NumeroDemande", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchSimul: Params = { CodeAgence: '', Table: "SimulationMourabaha", Colonne1: "CodeSimul", Colonne2: "Nomcli", Colagence: '101', Choix: 22 }
let searchParamsMourabaha: Params = { CodeAgence: '', Table: "ParamsMourabaha", Colonne1: "CodeMourabaha", Colonne2: "LibelleMourabaha", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchPeriod: Params = { CodeAgence: '', Table: "v_period_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchObjet: Params = { CodeAgence: 'OBJETFIN', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchMotif: Params = { CodeAgence: 'MOTIFPRET', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchActivite: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

// ==================== FONCTION DE STYLE DU STATUT ====================
/**
 * Retourne la couleur, le fond et le libellé du statut à afficher.
 * On se base prioritairement sur StatutDemande ; si absent, on retombe sur EtapeActuelle.
 */
const getStatutStyle = (etape?: string, statutDemande?: string) => {
  const statutUpper = (statutDemande || '').toUpperCase();
  const etapeUpper = (etape || '').toUpperCase();

  switch (statutUpper) {
    case 'EN_ATTENTE':
      return { color: '#faad14', bg: '#fffbe6', label: 'En attente' };
    case 'VALIDEE':
    case 'VALIDÉE':
      return { color: '#52c41a', bg: '#f6ffed', label: 'Validée' };
    case 'REJET':
    case 'REJETEE':
    case 'REJETÉE':
      return { color: '#f5222d', bg: '#fff1f0', label: 'Rejetée' };
    case 'EN_ANALYSE':
      return { color: '#1890ff', bg: '#e6f7ff', label: 'En analyse' };
    case 'BROUILLON':
      return { color: '#8c8c8c', bg: '#f5f5f5', label: 'Brouillon' };
    case 'ANNULE':
    case 'ANNULÉE':
      return { color: '#8c8c8c', bg: '#f5f5f5', label: 'Annulée' };
  }

  // Fallback : si StatutDemande est vide mais qu'on a un EtapeActuelle
  if (etapeUpper) {
    return { color: '#8c8c8c', bg: '#f5f5f5', label: etapeUpper };
  }

  return { color: '#8c8c8c', bg: '#f5f5f5', label: 'Non défini' };
};

// ==================== COMPOSANT ====================
function Tab1(props: { form?: any, disabled?: boolean, LoadGarantie: Function, setIsGarantieOblig?: Function }) {
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const [Numcli, setNumcli] = useState("")
  const [CodeMourabaha, setCodeMourabaha] = useState("")
  const [loading, setLoading] = useState(false);
  const [infoParams, setInfoParams] = useState<any>(null);
  const authHeader = useAuthHeader()

  // Hook pour récupérer le coût de l'actif
  const { getCoutInitial } = useActifService();

  // ==================== OBSERVATEURS ====================
  // ✅ useWatch pour le statut (fonctionne avec le Form.Item enregistré plus bas)
  const EtapeActuelle = Form.useWatch('EtapeActuelle', props.form);
  const StatutDemande = Form.useWatch('StatutDemande', props.form);
  const codeMourabahaValue = Form.useWatch('CodeMourabaha', props.form);

  // Les autres champs ne sont sélectionnables qu'après le choix du Code Mourabaha
  const fieldsDisabled = !codeMourabahaValue;

  let searchNumCompte: Params = { CodeAgence: Numcli, Table: "ViewAnyMourabahaCptRembousement", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "NUMCLI", colfiltre: "CodeMourabaha", valfiltre: CodeMourabaha, Choix: 22 }

  let searchActif: Params = { CodeAgence: '', Table: "ViewAnyActifMourabaha", Colonne1: "CodeActif", Colonne2: "Designation", Colagence: '', colfiltre: "CodeMourabaha", valfiltre: CodeMourabaha, Choix: 22 }

  // ==================== CONSULTATION TYPE MOURABAHA ====================
  function consultTypeMourabaha() {
    if (props.form.getFieldValue("CodeMourabaha") == null) {
      SweetAlert.fire({ title: "Svp renseigner le Code du type de Mourabaha ", icon: "warning" });
    } else {
      let data = Crypter.encrypt(props.form.getFieldValue("CodeMourabaha"));
      if (data.length != 0) {
        setLoading(true)
        let config =
        {
          method: 'get',
          maxBodyLength: Infinity,
          url: Datas.ApiUrl.ReadParamsMourabaha,
          headers: {
            'CypherCodeMourabaha': data,
            'Authorization': authHeader(),
            'Content-Type': 'application/json'
          },
        };

        axios.request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              if (res.StatutCode == 200) {
                const params = res.Result.Table1[0];

                props.form.setFieldValue("CodeFrais", res.Result.Table3?.map((x: any) => x.CODOPE) || []);
                props.form.setFieldValue("MontantFrais", params.MontantFrais);
                // Rend la garantie obligatoire uniquement si le paramètre l'exige.
                props.setIsGarantieOblig?.(params.IsGarantieObligatoir === true || params.IsGarantieObligatoir === 'true');
                setInfoParams(params);
              }
              else {
                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
              }
            }
            setLoading(false)
          })
          .catch((error) => {
            setLoading(false);
            console.log(error)
            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
          });
      }
    }
  }

  // ==================== CHANGEMENT DE CLIENT ====================
  function handleClientChange() {
    props.form.setFieldValue("CPTREMBOURSEMENT", '');
    if (props.form.getFieldValue("NUMCLI")) {
      setNumcli(props.form.getFieldValue("NUMCLI"))
    }
  }

  // ==================== CHANGEMENT D'ACTIF ====================
  const handleActifChange = async () => {
    const codeActif = props.form.getFieldValue('CodeActif');
    if (codeActif) {
      const cout = await getCoutInitial(codeActif);
      if (cout !== null) {
        props.form.setFieldValue('CoutAchatDemande', cout);
      }
    }
  };

  // ==================== CHARGEMENT D'UNE SIMULATION ====================
  function load() {
    let data = Crypter.encrypt(props.form.getFieldValue("CodeSimul"));
    let codeSimul = props.form.getFieldValue("CodeSimul")

    if (data.length != 0) {
      setLoading(true)
      props.form.resetFields();
      setInfoParams(null);
      props.setIsGarantieOblig?.(false);
      props.form.setFieldValue('CodeSimul', codeSimul)
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Datas.ApiUrl.ReadSimulationMourabaha,
        headers: {
          'CypherCode': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode == 200) {
              const sim = res.Result.Table2[0];
              props.form.setFieldsValue({
                ...sim,
                CodeSimul: sim.CodeSimul,
                CodeMourabaha: sim.CodeMourabaha,
                lib_CodeMourabaha: sim.lib_CodeMourabaha ?? sim.LibelleMourabaha,
                NUMCLI: sim.Numcli,
                NOMCLI: sim.NOMCLI ?? sim.NOM ?? sim.Nomcli,
                lib_NUMCLI: sim.lib_NUMCLI ?? sim.NOM ?? sim.Nomcli,
                CODOBJECT: sim.CODOBJECT,
                lib_CODOBJECT: sim.lib_CODOBJECT ?? sim.LibelleObjet,
                MOTIFDEM: sim.MOTIFDEM,
                lib_MOTIFDEM: sim.lib_MOTIFDEM ?? sim.LibelleMotif,
                CODACTIVE: sim.CODACTIVE,
                lib_CODACTIVE: sim.lib_CODACTIVE ?? sim.LibelleActivite,
                CodeActif: sim.CodeActif,
                lib_CodeActif: sim.lib_CodeActif ?? sim.Designation,
                CoutAchatDemande: sim.CoutAchatDemande ?? sim.CoutAchatActif,
                MargeMourabahaDem: sim.MargeMourabahaDem ?? sim.MargeBenefice,
                Quantite: sim.Quantite,
                NombreEch: sim.NombreEch,
                Periodicite: sim.Periodicite,
                lib_Periodicite: sim.lib_Periodicite ?? sim.LibellePeriodicite,
                DatePremEch: sim.DatePremEch ? ReformatDate(sim.DatePremEch) : undefined,
                MontantCharge: sim.MontantCharge,
                MontantPromesse: sim.MontantPromesse,
                CommentaireDemande: sim.CommentaireDemande,
                CPTREMBOURSEMENT: '',
              });

              // Executeafter : mêmes traitements qu'une sélection manuelle des champs remplis
              handleClientChange();
              props.LoadGarantie();
              setCodeMourabaha(sim.CodeMourabaha);
              consultTypeMourabaha();
              handleActifChange();
            }
            else {
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
        });
    }
  }

  // ==================== STYLE DU STATUT ====================
  const statutStyle = getStatutStyle(EtapeActuelle, StatutDemande);

  // ==================== RENDU ====================
  return (
    <div className='tabItem'>
      <div>
        <Box fontStyle={"inherit"} display={"flex"}>
          <SearchModal notRequired width={7} form={props.form} Titre='Recherche de simulation Mourabaha' label='Code Simulation' name='CodeSimul' Parametre={searchSimul} />
          <Button onClick={load} style={{ top: '10px', color: 'white' }} className='bt_add' type="ghost">
            {loading ? <CircularProgress size={"20px"} /> : "Load"}
          </Button>
        </Box>

        <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>

          {/* ✅ CHAMPS CACHÉS : enregistre EtapeActuelle et StatutDemande dans le formulaire pour Form.useWatch */}
          <Form.Item name="EtapeActuelle" noStyle>
            <input type="hidden" />
          </Form.Item>
          <Form.Item name="StatutDemande" noStyle>
            <input type="hidden" />
          </Form.Item>

          {/* ===== BANDEAU DE STATUT (visible en consultation) ===== */}
          {!props.disabled && (EtapeActuelle || StatutDemande) && (
            <Grid item xs={12} md={12} lg={12} sx={{ p: 0 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 2,
                  px: 2,
                  py: 1.5,
                  bgcolor: statutStyle.bg,
                  borderBottom: `2px solid ${statutStyle.color}`,
                  borderRadius: '4px 4px 0 0',
                }}
              >
                <Typography sx={{ fontWeight: 700, fontSize: 13, color: '#333' }}>
                  Statut de la demande :
                </Typography>
                <Chip
                  label={statutStyle.label}
                  sx={{
                    bgcolor: statutStyle.color,
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: 12,
                    height: 26,
                  }}
                />
                <Typography sx={{ ml: 'auto', fontSize: 12, color: '#666' }}>
                  Étape code : <b>{EtapeActuelle || 'N/A'}</b>
                </Typography>
              </Box>
            </Grid>
          )}

          {/* ======= COLONNE GAUCHE ======= */}
          <Grid item xs={12} md={6} lg={6} className='border-left'>
            <SearchInput dissabledCode={props.disabled} notRequired width={4} form={props.form} Titre='Recherche Numéro de demande Mourabaha' label='Numéro' name='NumeroDemande' Parametre={searchFinForm} />
            <SearchModal handleFunction={() => { setCodeMourabaha(props.form.getFieldValue("CodeMourabaha")) }} ExecuteafterSelect1={consultTypeMourabaha} width={4} form={props.form} Titre="Recherche Type de Mourabaha" label='Code Mourabaha' name='CodeMourabaha' Parametre={searchParamsMourabaha} />
            <SearchModal disabled={fieldsDisabled} ExecuteafterSelect1={props.LoadGarantie} ExecuteafterSelect2={handleClientChange} width={4} form={props.form} Titre="Recherche Indice client" label='Numéro du client' name='NUMCLI' Parametre={searchIndice} />
            {/* <Box margin={1} fontStyle={'inherit'}> */}
            <SearchModal disabled={fieldsDisabled} width={4} form={props.form} Titre="Compte de remboursement " label='Compte de remboursement' name='CPTREMBOURSEMENT' Parametre={searchNumCompte} />
            {/* <InputForm width={12} label="Compte remboursement" name="CPTREMBOURSEMENT" type={''} /> */}
            {/* </Box> */}

            <SearchModal disabled={fieldsDisabled} width={4} form={props.form} Titre="Recherche Objet du financement" label='Objet' name='CODOBJECT' Parametre={searchObjet} />
            <SearchModal disabled={fieldsDisabled} width={4} form={props.form} Titre="Recherche Motif " label='Motif' name='MOTIFDEM' Parametre={searchMotif} />

            <SearchModal disabled={fieldsDisabled} width={4} form={props.form} Titre="Recherche de l'activité du client " label='Activité' name='CODACTIVE' Parametre={searchActivite} />

            {/* Ligne modifiée avec l'ajout de ExecuteafterSelect2 */}
            <SearchModal
              width={4}
              form={props.form}
              Titre="Recherche de l'actif"
              label='Actif'
              name='CodeActif'
              Parametre={searchActif}
              ExecuteafterSelect2={handleActifChange}
              disabled={fieldsDisabled}
            />

            <InputForm disabled={fieldsDisabled} defaultValue={1} width={4} label='Quantité' name='Quantite' type='number' />

            {/* <InputForm notRequired width={4} money label='Prix Unitaire' name='Unite' type='number' /> */}

          </Grid>

          <Grid item xs={12} md={6} lg={6} className='border-left'>
            <InputForm disabled={fieldsDisabled} width={4} money label='Montant du financement (Coût achat)' name='CoutAchatDemande' type='number' rules={infoParams ? [{ validator: (_: any, value: any) => { if (value && Number(value) > Number(infoParams.MontantMaxAuto)) { return Promise.reject(new Error('Montant supérieur au max autorisé (' + Number(infoParams.MontantMaxAuto).toLocaleString('fr-FR') + ')')); } return Promise.resolve(); } }] : []} />
            {/* {infoParams && (
                <Typography variant="caption" color="error" sx={{ display: 'block', ml: 1, mb: 1 }}>
                    Montant max autorisé: {Number(infoParams.MontantMaxAuto).toLocaleString('fr-FR')}{infoParams.IsTaxable === false ? ' | Non taxable' : ''}{infoParams.MontantMinTax > 0 ? ' | Montant min taxe: ' + Number(infoParams.MontantMinTax).toLocaleString('fr-FR') : ''}
                </Typography>
            )} */}
            <InputForm disabled={fieldsDisabled} width={4} money label='Marge' name='MargeMourabahaDem' type='number' rules={infoParams ? [{ validator: (_: any, value: any) => { if (value && Number(value) < Number(infoParams.TauxMargeMin)) { return Promise.reject(new Error('Marge inférieure au minimum (' + infoParams.TauxMargeMin + '%)')); } return Promise.resolve(); } }] : []} />
            <InputForm disabled={fieldsDisabled} width={4} money label='Charge' name='MontantCharge' type='number' />
            <InputForm disabled={fieldsDisabled} width={4} money label='Promesse' name='MontantPromesse' type='number' />
            {/* {infoParams && (
            {/* {infoParams && (
                <Typography variant="caption" color="error" sx={{ display: 'block', ml: 1, mb: 1 }}>
                    Taux marge min: {infoParams.TauxMargeMin}%
                </Typography>
            )} */}

            <SearchModal disabled={fieldsDisabled} width={4} form={props.form} Titre="Recherche Périodicité" label='Periodicite' name='Periodicite' Parametre={searchPeriod} />
            {/* {infoParams && (
                <Typography variant="caption" color="error" sx={{ display: 'block', ml: 1, mb: 1 }}>
                    Taux périodicité: {infoParams.TauxP}%
                </Typography>
            )} */}
            <InputForm disabled={fieldsDisabled} width={4} money label='Nombre Echéance' icon={<SwipeUp color='disabled' fontSize='small' />} name='NombreEch' type='number' error='mobile' rules={infoParams ? [{ validator: (_: any, value: any) => { if (value && Number(value) > Number(infoParams.NbrEchMax)) { return Promise.reject(new Error('Nombre d\'échéances supérieur au max (' + infoParams.NbrEchMax + ')')); } return Promise.resolve(); } }] : []} />
            {/* {infoParams && (
                <Typography variant="caption" color="error" sx={{ display: 'block', ml: 1, mb: 1 }}>
                    Nb échéances max: {infoParams.NbrEchMax}
                </Typography>
            )} */}
            <InputForm disabled={fieldsDisabled} width={4} label='Date 1ère remboursement' name='DatePremEch' type='date' rules={[{ validator: (_: any, value: any) => { if (value && user.datjour && new Date(value) < new Date(formatDate(user.datjour))) { return Promise.reject(new Error('La date de première échéance ne peut pas être antérieure à la date comptable (' + formatDate(user.datjour) + ')')); } return Promise.resolve(); } }]} />
            <InputForm notRequired width={4} disabled money label='Frais de service' name='MontantFrais' type='number' />
          </Grid>

          <Grid item xs={12} md={12} lg={12} className='border-left'>
            <InputForm disabled={fieldsDisabled} width={4} label='Commentaire' name='CommentaireDemande' type='TextArea' />
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default Tab1;